import { render, staticRenderFns } from "./CSelectDefaultValue.vue?vue&type=template&id=f3d63c48&"
import script from "./CSelectDefaultValue.vue?vue&type=script&lang=js&"
export * from "./CSelectDefaultValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports